// Copyright (c) 2018 Deere & Company

import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import t from 'tcomb';

const Claims = t.list(ClaimSearchResult, 'Claims');

export const getDefaultState = () =>
    new Claims([]);

export default Claims;



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/state/claims.js